export default {
  __name: 'ConfirmSlotModal',
  props: {
    clickOk: Function,
    clickCancel: Function
  },
  setup: function setup(__props) {
    return {
      __sfc: true
    };
  }
};